module.exports = __webpack_public_path__ + "static/media/1_l_fonar_0.26_53.33.92044f44.png";